// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getFirestore } from "@firebase/firestore";
import { getStorage } from "firebase/storage";
import { getAuth } from "firebase/auth";
import { initializeAppCheck, ReCaptchaV3Provider, setTokenAutoRefreshEnabled } from "firebase/app-check";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: process.env.REACT_APP_API_KEY,
  authDomain: process.env.REACT_APP_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_PROJECT_ID,
  storageBucket: process.env.REACT_APP_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_APP_ID,
  measurementId: process.env.REACT_APP_MEASUREMENT_ID,
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const server = process.env.REACT_APP_SERVER;
const firestore = getFirestore(app);
const userAuth = getAuth(app);
const storage = getStorage(app);

// Initialize App Check with ReCaptchaV3 (singleton, initialized once)
let appCheckInstance = null;
let isAppCheckInitialized = false;

const recaptchaSiteKey = process.env.REACT_APP_RECAPTCHA_V3_SITE_KEY || process.env.VITE_RECAPTCHA_V3_SITE_KEY;

// Enable Firebase App Check debug token in development mode
// This avoids reCAPTCHA throttling and 24h cooldowns during local development
//
// Uses a FIXED token from REACT_APP_APPCHECK_DEBUG_TOKEN, pinned in
// .env.development. With `= true` the SDK mints a RANDOM token per browser
// *origin* and stores it there, so it silently rotates when you switch between
// http://localhost:3000 and http://lvh.me:3000 (needed for Phone Auth), use
// incognito, or clear storage — and every rotation means re-registering the new
// UUID or getting 403 exchangeDebugToken. A fixed token is registered once.
//
// It lives in the tracked .env.development by team decision (private repo, two
// people) rather than in the gitignored .env.development.local. What it grants
// is an App Check bypass for DEV builds only — this block is behind
// NODE_ENV === 'development', so a production bundle never reads it — and it
// only works for tokens registered in that project's console. If the repo ever
// opens up, delete the token from the console and move the value to
// .env.development.local.
const isDevelopment = process.env.NODE_ENV === 'development';
if (isDevelopment && typeof window !== 'undefined') {
  window.FIREBASE_APPCHECK_DEBUG_TOKEN =
    process.env.REACT_APP_APPCHECK_DEBUG_TOKEN || true;
}

// Getter singleton for App Check instance
const getAppCheckInstance = () => {
  // If already initialized, return the existing instance
  if (isAppCheckInitialized && appCheckInstance) {
    return appCheckInstance;
  }

  // If not initialized and we have the site key, initialize it
  if (!isAppCheckInitialized && recaptchaSiteKey) {
    try {
      // Initialize with auto-refresh disabled to avoid proactive refresh errors
      // In development, debug token is enabled via window.FIREBASE_APPCHECK_DEBUG_TOKEN
      // In production, reCAPTCHA v3 is used normally
      appCheckInstance = initializeAppCheck(app, {
        provider: new ReCaptchaV3Provider(recaptchaSiteKey),
        isTokenAutoRefreshEnabled: false,
      });
      
      // Enable auto-refresh once after initialization
      setTokenAutoRefreshEnabled(appCheckInstance, true);
      isAppCheckInitialized = true;
    } catch (error) {
      // If initialization fails (e.g., already initialized elsewhere), return null
      console.warn("App Check initialization failed:", error);
      return null;
    }
  }

  return appCheckInstance;
};

export { app, getAppCheckInstance, firestore, userAuth, server, storage };
